
const APIRoute = "https://www.madhos.co/backend_web_madhos";

const API = {
    getMenu : APIRoute + "/get_menu.php",
    getProductos : APIRoute + "/get_productos.php",
    getFichaTecnica : APIRoute + "/get_ficha_tecnica_producto.php"
}

export default API;